
import React, { useState } from 'react';
import { Camera, Book, Heart, Play, Pause, Video, Mic, Upload, Users, Home, Settings, Star, Cloud, Moon, Sun, ChevronRight, Plus, Check, X, Mail, Lock, User, ArrowRight } from 'lucide-react';

export const Card = ({ children, style = {}, hover = false }) => {
  return (
    <div style={{
      background: 'white',
      borderRadius: '1rem',
      padding: '1.5rem',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      transition: hover ? 'box-shadow 0.3s' : 'none',
      ...style
    }}
    onMouseOver={(e) => hover && (e.currentTarget.style.boxShadow = '0 10px 15px rgba(0,0,0,0.15)')}
    onMouseOut={(e) => hover && (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)')}
    >
      {children}
    </div>
  );
};